export default __webpack_public_path__ + "static/media/Bass Warwick heavy funk groove on E 120 BPM (1).52c24c81.mp3";